import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '../../../i18n/language-context';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';
import { Globe } from 'lucide-react';
import { useCommonStore } from 'state/store/common/useCommonStore';
import { updateCurrentLanguage } from './services/language-service';
import { useConfig } from 'hooks/use-config';

function LanguageSelector() {
  const { t } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const user = useCommonStore((state) => state.user);
  const { currentLanguage, setLanguage, availableLanguages, isLoading } = useLanguageContext();
  const { configurationSettings } = useConfig();

  const changeLanguage = async (newLanguageCode: string) => {
    if (user) {
      updateCurrentLanguage(user.id, newLanguageCode, configurationSettings);
    }
    await setLanguage(newLanguageCode);
  };

  return (
    <DropdownMenu open={isDropdownOpen} onOpenChange={setIsDropdownOpen}>
      {/* <DropdownMenuTrigger asChild className="cursor-pointer rounded-full hover:bg-muted">
        <div className="flex items-center justify-center gap-1 w-[36px] h-[36px] bg-muted rounded-full outline outline-1 outline-offset-[-1px] outline-gray-200">
          <span className="text-sm font-semibold uppercase">
            {currentLanguage.split('-')[0].toUpperCase()}
          </span>
        </div>
      </DropdownMenuTrigger> */}

      <DropdownMenuTrigger asChild className="cursor-pointer">
        <div className="flex items-center gap-2 px-1.5 sm:px-3 h-[36px] w-[36px] sm:w-auto rounded-full border border-border text-foreground">
          <Globe size={20} className="text-sm hidden sm:block" />
          <span className="font-medium text-sm sm:block">
            {currentLanguage.split('-')[0].toUpperCase()}
          </span>
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        {isLoading ? (
          <DropdownMenuItem disabled>{t('LOADING_LANGUAGES')}...</DropdownMenuItem>
        ) : !availableLanguages || availableLanguages.length === 0 ? (
          <DropdownMenuItem disabled>{t('PLEASE_LOGIN_FIRST_ACCESS_LANGUAGES')}</DropdownMenuItem>
        ) : availableLanguages && availableLanguages.length > 0 ? (
          availableLanguages.map((lang, i) => (
            <div key={lang.itemId}>
              <DropdownMenuItem
                className={`${lang.languageCode === currentLanguage ? 'font-bold cursor-pointer' : ''}`}
                onClick={() => changeLanguage(lang.languageCode)}
              >
                {lang.languageName}
              </DropdownMenuItem>
              {i !== availableLanguages.length - 1 && <DropdownMenuSeparator />}
            </div>
          ))
        ) : (
          <DropdownMenuItem disabled>{t('NO_LANGUAGES_AVAILABLE')}</DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default LanguageSelector;
